
import {Component} from 'vue-property-decorator';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import { mixins } from "vue-class-component";
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { RouterNameEnum } from '@/router/router.types';
import { getStudioId } from '@/UI/lib/state';

@Component({
    components: {
        BaseDataForm,
        PageTitle
    }
})

export default class Reports extends mixins (
    ProxyTableData
) {
    RouterNames = RouterNameEnum;
    salon = getStudioId(this)

    async created(): Promise<void> {
        this.formReady = false
        try {
            
        } catch (e) {
            console.error(e)
        } finally {
            this.formReady = true
        }
    }

}
